export { SmartScalar } from "./SmartScalar";
